/**
 * Converts a binary string (where each character represents one byte) to a
 * Uint8Array. This avoids the implicit UTF-8 encoding that occurs when passing
 * a string directly to the File or Blob constructor, which would corrupt any
 * byte values above 127.
 *
 * For strings that only contain ASCII characters (e.g. base64-encoded data),
 * this conversion is a safe no-op — the resulting bytes are identical to what
 * UTF-8 encoding would produce.
 */
export function binaryStringToUint8Array(binaryString: string): Uint8Array {
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i) & 0xff;
  }
  return bytes;
}
